import { render, staticRenderFns } from "./Repaired.vue?vue&type=template&id=0f0bc61c&scoped=true&"
import script from "./Repaired.vue?vue&type=script&lang=js&"
export * from "./Repaired.vue?vue&type=script&lang=js&"
import style0 from "./Repaired.vue?vue&type=style&index=0&id=0f0bc61c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0bc61c",
  null
  
)

export default component.exports